import React from "react";

const PrivacyNotice = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white mt-2 mb-6">
              Privacy Notice
            </h1>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          {/* Effective Date */}
          <p className="font-semibold text-gray-800">
            Effective Date: 01 Jan 2026
          </p>

          <p className="text-gray-700 leading-relaxed">
            At{" "}
            <span className="text-[#b32126] font-semibold">Infotech.works</span>
            , we are committed to protecting the privacy of our clients,
            employees, partners, and website visitors. This Privacy Notice
            outlines how we collect, use, disclose, and safeguard your personal
            information in accordance with applicable Indian laws, including the{" "}
            {""}
            <strong>Information Technology Act, 2000 </strong> and the{" "}
            <strong>Digital Personal Data Protection Act, 2023</strong>.
          </p>

          <hr className="border-gray-300" />

          {/* Section 1 */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>1. Scope of This Notice</strong>
            </h2>

            <p className="text-gray-700">This notice applies to:</p>

            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Visitors of our website</li>
              <li>Prospective and current clients</li>
              <li>Employees, job applicants, and independent contractors</li>
              <li>Vendors and service providers</li>
            </ul>
          </div>
          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>2. Information We Collect</strong>
            </h2>

            <p className="text-gray-700">
              We may collect the following categories of personal data:
            </p>

            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>From Website Visitors & Clients:</strong>
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Name, email, phone number, company name, designation</li>
              <li>
                Technical data: IP address, device information, browser type,
                pages visited (via cookies/analytics tools)
              </li>
            </ul>
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>From Job Applicants & Employees:</strong>
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>
                Personal identifiers: Name, contact details, PAN, Aadhaar (only
                where required)
              </li>
              <li>
                Employment records: Resume, educational qualifications, past
                employment
              </li>
              <li>Financial information: Salary, bank details (for payroll)</li>
              <li>
                Health or biometric data (only when required for employment or
                statutory compliance)
              </li>
            </ul>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>3. How We Use Your Information</strong>
            </h2>

            <p className="text-gray-700">We process your data to:</p>

            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Provide and improve our services</li>
              <li>Respond to business or employment inquiries</li>
              <li>EManage client relationships and contracts</li>
              <li>Conduct recruitment, HR operations, and payroll</li>
              <li>Meet legal and regulatory obligations</li>
            </ul>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>4. Employee & Applicant Privacy</strong>
            </h2>

            <p className="text-gray-700">
              Employee and candidate data is collected solely for HR and
              operational purposes. This includes recruitment, onboarding,
              compliance, payroll, performance management, and exit formalities.
              Sensitive personal data (e.g., Aadhaar or medical info) is
              processed only when necessary, with appropriate safeguards.
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>5. Legal Basis for Processing (India)</strong>
            </h2>

            <p className="text-gray-700">We process personal data based on:</p>

            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Your consent</li>
              <li>
                Performance of a contract (e.g., employment or service
                agreement)
              </li>
              <li>Legal obligations under Indian labor, tax, or IT laws</li>
              <li>
                Legitimate business interests (e.g., network security,
                operational analytics)
              </li>
            </ul>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>6. Data Sharing & Transfers</strong>
            </h2>

            <p className="text-gray-700">We may share your data with:</p>

            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>
                Trusted third-party service providers (e.g., payroll processors,
                hosting providers)
              </li>
              <li>Government or regulatory authorities, if legally required</li>
              <li>Affiliated entities or partners for service delivery</li>
            </ul>
            <p className="text-gray-700">
              We do <strong>not</strong> sell personal data. Cross-border data
              transfers (if any) are done in compliance with Indian legal
              standards.
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>7. Data Retention</strong>
            </h2>

            <p className="text-gray-700">
              We retain personal data only as long as necessary for the purposes
              listed or as mandated by Indian laws (e.g., tax or labor laws).
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>8. Your Rights</strong>
            </h2>

            <p className="text-gray-700">Under Indian law, you may:</p>

            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Request access or correction to your personal data</li>
              <li>Withdraw consent for future use (where applicable)</li>
              <li>
                File complaints with the Data Protection Board (once constituted
                under DPDP Act)
              </li>
            </ul>

            <p className="text-gray-700">
              To exercise your rights, write to us at:{" "}
              {/* <strong className="text-[#b32126]">contact@infotech.works</strong> */}
              <a
                href="mailto:contact@infotech.works"
                className="text-[#b32126] text-bold  hover:text-[#8cadc7] "
              >
                <strong>contact@infotech.works</strong>
              </a>
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>9. Data Security</strong>
            </h2>

            <p className="text-gray-700">
              We use reasonable technical and organizational measures to protect
              your personal data from unauthorized access, alteration, or loss.
              Employee and sensitive data is stored in secure, access-controlled
              environments.
            </p>
          </div>
          <hr className="border-gray-300" />
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>10. Cookies & Tracking Technologies</strong>
            </h2>

            <p className="text-gray-700">
              Our website uses cookies to enhance functionality and track usage
              patterns. You may choose to disable cookies via your browser
              settings.
            </p>
          </div>

          <hr className="border-gray-300" />
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>11. Updates to This Notice</strong>
            </h2>

            <p className="text-gray-700">
              We may periodically update this Privacy Notice to reflect legal or
              operational changes. Any revisions will be posted with the updated
              effective date.
            </p>
          </div>

          <hr className="border-gray-300" />
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>12. Contact Us</strong>
            </h2>
            <p className="text-gray-700">
              If you have questions, requests, or grievances regarding your
              personal data:
            </p>
            <p>
              📧 {""}
              <a
                href="mailto:contact@infotech.works"
                className="text-[#b32126]  hover:text-[#8cadc7] "
              >
                contact@infotech.works
              </a>
            </p>
            <span>
              📍 Infotech.works, Iris Wing E, Lane 5A, Baner-Balewadi Road,
              Pune, Maharashtra 411045, India
            </span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyNotice;
